import type { Project } from '@frameio/graphql-client/generated';
import { Box, Text } from '@frameio/vapor';
import { useQuickSearchProjectFragment } from '../../gql/generated/QuickSearchProject';
import { useNavigateToResult } from '../../hooks';
import { ProjectIcon } from '../shared/TypeIcon';
import type { ResultItemProps } from './ResultItemCell';
import { ResultItemCell } from './ResultItemCell';

export const ResultProjectItem = (
  props: Omit<ResultItemProps, 'href'> & { resultId: string }
) => {
  const { resultId } = props;
  const { data } = useQuickSearchProjectFragment({
    from: { __typename: 'Project', id: resultId },
  });

  const { id, name, private: isPrivate, archivedAt } = data as Project;
  const { href } = useNavigateToResult(id ?? '', data.__typename ?? '');
  const isRestrictedProject = isPrivate;
  const isInactiveProject = Boolean(archivedAt);
  const itemProps = {
    href,
    ...props,
  };
  return (
    <ResultItemCell {...itemProps}>
      <Box
        alignItems="center"
        display="flex"
        height={24}
        justifyContent="center"
        width={24}
      >
        <ProjectIcon
          isInactiveProject={isInactiveProject}
          isRestrictedProject={isRestrictedProject}
        />
      </Box>

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Text enableTooltip={true} truncate={true} variant="body">
          {name}
        </Text>
      </Box>
    </ResultItemCell>
  );
};
